import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { BatchRequestsService } from './api/batchRequests.service';
import { InfocodesSetService } from './api/infocodesSet.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class InfoCodesApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<InfoCodesApiModule> {
        return {
            ngModule: InfoCodesApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: InfoCodesApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('InfoCodesApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
